export default "__VITE_ASSET__S2QOIuai__"